import useTranslation from 'next-translate/useTranslation';

import { Button } from '~/domains/design-system/Button';

interface SignUpContinueButtonProps {
  onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  'data-test-id'?: string;
  /** Custom button text. Defaults to "Continue" */
  buttonText?: string;
}

/**
 * Presentational component for the sign-up continue button.
 * Use ConnectedSignUpContinueButton to include the registration bonus banner.
 */
export function SignUpContinueButton({
  onClick,
  disabled,
  loading,
  className,
  'data-test-id': dataTestId,
  buttonText,
}: SignUpContinueButtonProps) {
  const { t } = useTranslation('auth');

  return (
    <Button
      type="button"
      fullWidth
      variant="primary-fill"
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      className={className}
      data-test-id={dataTestId}
    >
      {buttonText || t('signUpActions.continue')}
    </Button>
  );
}
